import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import type { ListTabConfigurationRoleEntity } from './list-tab-configuration-role.entity';

export type TabConfigurationVisibility = 'organization' | 'role';

@Index('idx_tab_config_list_key', ['listKey'], {})
@Index('idx_tab_config_visibility', ['visibility'], {})
@Index('idx_tab_config_list_visibility', ['listKey', 'visibility'], {})
@Index('idx_tab_config_sort', ['listKey', 'sortOrder', 'deletedDate'])
@Entity('list_tab_configuration')
export class ListTabConfigurationEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('varchar', { name: '_list_key', length: 100 })
	public listKey!: string;

	@Column('enum', {
		name: 'visibility',
		enum: ['organization', 'role'],
		default: 'organization',
	})
	public visibility!: TabConfigurationVisibility;

	@Column('int', {
		name: 'sortOrder',
		nullable: true,
		unsigned: true,
		default: () => "'0'",
	})
	public sortOrder!: number;

	@Column('json', { name: '_tab_ids' })
	public tabIds!: Array<string>;

	@OneToMany(
		'ListTabConfigurationRoleEntity',
		(role: ListTabConfigurationRoleEntity) => role.fkTabConfiguration,
	)
	public sharedRoles!: Array<ListTabConfigurationRoleEntity>;
}
